import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1d66de0c")
const _hoisted_1 = { class: "company-contract" }
const _hoisted_2 = { class: "contract-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "用户管理规则公约及数据处理条款", -1)
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = {
  key: 1,
  class: "code-btn disabled"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_8 = {
  key: 0,
  class: "contract-iframe"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("我已知晓")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Verify = _resolveComponent("Verify")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          "label-position": "top",
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "手机号",
              prop: "mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _ctx.form.mobile,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.form.mobile = $event)),
                  placeholder: "请输入与授权书一致的手机号",
                  onInput: _ctx.handleMobileInput
                }, null, 8, ["modelValue", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "验证码",
              prop: "smsCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _ctx.form.smsCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.smsCode = $event)),
                  placeholder: "请输入验证码",
                  onInput: _ctx.handleSmsCodeInput
                }, {
                  suffix: _withCtx(() => [
                    (_ctx.countDown === 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "code-btn",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showVerify && _ctx.showVerify(...args)))
                        }, "获取验证码"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, "重新获取(" + _toDisplayString(_ctx.countDown) + "s)", 1))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "企业名称",
              prop: "corpName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _ctx.form.corpName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.corpName = $event)),
                  placeholder: "请输入合作企业名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "agree" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.form.agree,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.agree = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_6,
                _createElementVNode("span", {
                  class: "agreement-link",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.contractVisible = true))
                }, "《用户管理规则公约及数据处理条款》")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "submit-btn",
          onClick: _ctx.submit,
          disabled: !_ctx.subimtAbled
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    (_ctx.contractVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("iframe", {
            src: _ctx.htmlContent,
            frameborder: "0"
          }, null, 8, _hoisted_9),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "agree-btn",
            onClick: _ctx.agree
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Verify, {
      lang: "zh",
      areaCode: 86,
      imgSize: { width: '400px', height: '200px' },
      ref: "verify",
      onSuccess: _ctx.verifySuccess
    }, null, 8, ["onSuccess"])
  ]))
}